import * as isNode from 'detect-node';

// eslint-disable-next-line import/no-mutable-exports
let isReallyNode = isNode;

if (process.env.NODE_ENV === 'test') {
  isReallyNode = false;
}

export default isReallyNode;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/is-node.ts